import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5836dbae&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5836dbae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836dbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5836dbae')) {
      api.createRecord('5836dbae', component.options)
    } else {
      api.reload('5836dbae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5836dbae&scoped=true", function () {
      api.rerender('5836dbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/getLow/index.vue"
export default component.exports